import React, { useEffect, useState } from "react"
import Img from "gatsby-image"
import "./header-product.scss"

const HeaderProduct = ({ banner }) => {
  return (
    <Img
      fluid={[
        banner[1].fluid,
        { media: `(min-width: 1024px)`, ...banner[0].fluid },
      ]}
      alt={banner[0].description}
      className="f-header-product"
    />
  )
}

export default HeaderProduct
